import { useContext, useReducer } from 'react';
import { publicClientApp } from '../config/msal-config';
import { log } from 'console';
import { fetchUserDetails } from '../config/graph-service';
import { useNavigate } from 'react-router-dom';


type State = {
	username: string
	password: string
	isButtonDisabled: boolean
	helperText: string
	isError: boolean
	loading: boolean
};

const initialState: State = {
	username: '',
	password: '',
	isButtonDisabled: true,
	helperText: '',
	isError: false,
	loading: false
};

type Action = { type: 'setUsername', payload: string }
	| { type: 'setPassword', payload: string }
	| { type: 'setIsButtonDisabled', payload: boolean }
	| { type: 'loginSuccess', payload: string }
	| { type: 'loginFailed', payload: string }
	| { type: 'setIsError', payload: boolean }
	| { type: 'setLoading', payload: boolean };


const reducer = (state: State, action: Action): State => {
	switch (action.type) {
		case 'setUsername':
			return {
				...state,
				username: action.payload
			};
		case 'setPassword':
			return {
				...state,
				password: action.payload
			};
		case 'setIsButtonDisabled':
			return {
				...state,
				isButtonDisabled: action.payload
			};
		case 'loginSuccess':
			return {
				...state,
				helperText: action.payload,
				isError: false
			};
		case 'loginFailed':
			return {
				...state,
				helperText: action.payload,
				isError: true
			};
		case 'setIsError':
			return {
				...state,
				isError: action.payload
			};
		case 'setLoading':
			return {
				...state,
				loading: action.payload
			};
	}
}

const useMsalAuth = () => {
	const [dispatch] = useReducer(reducer, initialState);

	// const navigate = useNavigate();


	const getUserProfile = async () => {
		if (!publicClientApp.getAccount()) {
			return;
		}
		try {

			const token = await getAccessToken();
			const accessToken = token ? token : '';
	
			if (accessToken) {
				localStorage.setItem('authToken', accessToken);
				const data = await fetchUserDetails(accessToken);
				console.log(data.mail);

				localStorage.setItem("accessToken", accessToken)

			}
		} catch (err) {
			console.log(err); // to handle error messages in future
		}
	};

	const getAccessToken = async () => {
		const scopes = [process.env.REACT_APP_MS_SCOPES ? process.env.REACT_APP_MS_SCOPES : ""];
		// clearing cookies
		document.cookie.split(';').forEach(function (c) {
			const sanitizedCookie = c.replace(/[^a-zA-Z0-9=; ]/g, ''); // Sanitize input
			document.cookie = sanitizedCookie.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
		});
		try {
			const { accessToken } = await publicClientApp.acquireTokenSilent({ scopes });
			return accessToken;
		} catch (err) {
			await publicClientApp.acquireTokenRedirect({ scopes });
		}
	};

	return { getUserProfile };
};

export default useMsalAuth;
